import * as Updates from "expo-updates";

import {
  type DiagnosticItem,
  DiagnosticStatus,
} from "@/schemas/app/diagnostic";

export function useUpdateInfo(): DiagnosticItem[] {
  const { currentlyRunning, availableUpdate } = Updates.useUpdates();

  // Get current update information
  const currentUpdateId = currentlyRunning.updateId || "Not available";
  const runtimeVersion = currentlyRunning.runtimeVersion || "Not available";
  const updateChannel = Updates.channel || "Not available";

  // Get available update information
  const isUpdateAvailable = availableUpdate ? "Yes" : "No";
  const availableUpdateId = availableUpdate?.manifest?.id || "Not available";

  const diagnosticItems: DiagnosticItem[] = [
    {
      id: "updateChannel",
      name: "Update Channel",
      value: updateChannel,
      status:
        updateChannel !== "Not available"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.WARNING,
    },
    {
      id: "currentUpdateId",
      name: "Current Update ID",
      value: currentUpdateId,
      status:
        currentUpdateId !== "Not available"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.WARNING,
    },
    {
      id: "runtimeVersion",
      name: "Runtime Version",
      value: runtimeVersion,
      status:
        runtimeVersion !== "Not available"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.WARNING,
    },
    {
      id: "isUpdateAvailable",
      name: "Update Available",
      value: isUpdateAvailable,
      status: availableUpdate ? DiagnosticStatus.WARNING : DiagnosticStatus.OK,
    },
  ];

  if (availableUpdate !== null && availableUpdate !== undefined) {
    const updateIdInfo = {
      id: "availableUpdateId",
      name: "Available Update ID",
      value: availableUpdateId,
      status:
        availableUpdateId !== "Not available"
          ? DiagnosticStatus.OK
          : DiagnosticStatus.ERROR,
    };
    return [...diagnosticItems, updateIdInfo];
  } else {
    return diagnosticItems;
  }
}
